export default __webpack_public_path__ + "static/media/call-logo.527c3677.svg";